var fowtr_module_chapter_2 = (function (fowtr_module_chapter_2) {

    fowtr_module_chapter_2.init = function(chapter){
      
      if(fowtr_module_chapter_2.controller){
        // console.log('destroying fowtr_module_chapter_2.controller');
        fowtr_module_chapter_2.controller.destroy(true);
        fowtr_module_chapter_2.controller = null;
      }
      // gsap.killTweensOf("*");
      gsap.globalTimeline.clear();

      // console.log('fowtr_module_chapter_2 initialised');

      if(!fowtr_module_utilities.disableFancyStuff) {
        $("#fowtr-chapter2 #fowtr-article1 .fowtr-parallax-bg video").prop('muted', true);
        $("#fowtr-chapter2 #fowtr-article1 .fowtr-parallax-bg video").get(0).play();
      }




      // Video
      var mainVideo = $('#fowtr-chapter2 #fowtr-article1 video');
      // var baseSrc = 'https://dhl-future-of-work-trend-report.fra1.cdn.digitaloceanspaces.com/video/';
      mainVideo.removeAttr('src');
      var baseSrc = mainVideo.attr('data-base-ref') + 'Timelapse-short-version-';
      if($(window).width() > 1000) {
        mainVideo.append("<source type='video/mp4' src='"+baseSrc+"1920x1080.mp4' />");
      } else if($(window).width() > 700) {
        mainVideo.append("<source type='video/mp4' src='"+baseSrc+"1920x1080.mp4' />");
      } else if($(window).width() > 400) {
        mainVideo.append("<source type='video/mp4' src='"+baseSrc+"1280x720.mp4' />");
      } else if($(window).width() > 300) {
        mainVideo.append("<source type='video/mp4' src='"+baseSrc+"852x480.mp4' />");
      } else {
        mainVideo.append("<source type='video/mp4' src='"+baseSrc+"352x240.mp4' />");
      }




      // PARALLAX CONTROLLER
      // duration is 300% - meaning, if will 'do stuff' for 300% of the height - and as they are 100% height, that covers them 'coming in', 'in', and 'going out' of viewport

      fowtr_module_chapter_2.controller = new ScrollMagic.Controller({
        globalSceneOptions: {
          // triggerHook: "onEnter",
          // duration: "300%"
        }});

      if(fowtr_module_utilities.disableFancyStuff) fowtr_module_chapter_2.controller = null;

      // ------------------------------------------------------------------------------------------------------
      // article 1
      // ------------------------------------------------------------------------------------------------------
      // $('#fowtr-chapter2 #fowtr-article1 .fowtr-parallax-bg').css({'top':'auto','bottom':'0','height':'110%',});
      new ScrollMagic.Scene({triggerElement: "#fowtr-chapter2 #fowtr-article2", duration: "100%", triggerHook: "onEnter"})
              .setTween("#fowtr-chapter2 #fowtr-article1 > .fowtr-parallax-bg", {y: "50%", opacity:0, ease: Linear.easeNone})
              .addTo(fowtr_module_chapter_2.controller);






      // ------------------------------------------------------------------------------------------------------
      // article 2 forklift animations
      // ------------------------------------------------------------------------------------------------------


      var forkliftTl = new TimelineMax({paused: true});

      forkliftTl.fromTo($('#fowtr-chapter2 #fowtr-article2 .forklift-group'),3,{opacity:0,x:"-200%"},{opacity:1,x:0,ease:Power4.easeOut},0);
      forkliftTl.fromTo($('#fowtr-chapter2 #fowtr-article2 .forklift-front-wheel'),3,{rotation:-830},{rotation:0,ease:Power4.easeOut},0);
      forkliftTl.fromTo($('#fowtr-chapter2 #fowtr-article2 .forklift-back-wheel'),3,{rotation:-830},{rotation:0,ease:Power4.easeOut},0);
      forkliftTl.fromTo($('#fowtr-chapter2 #fowtr-article2 .forklift-bar'),2.5,{y:"-100%"},{y:0,ease:Power4.easeInOut},0.5);

      var peopleStartTime = 0.6;
      forkliftTl.fromTo($('#fowtr-chapter2 #fowtr-article2 .person1'),2,{scale:0.8,opacity:0},{scale:1,opacity:1,ease:Power4.easeOut},peopleStartTime);
      forkliftTl.fromTo($('#fowtr-chapter2 #fowtr-article2 .person2'),2,{scale:0.8,opacity:0},{scale:1,opacity:1,ease:Power4.easeOut},peopleStartTime + 0.2);
      forkliftTl.fromTo($('#fowtr-chapter2 #fowtr-article2 .person3'),2,{scale:0.8,opacity:0},{scale:1,opacity:1,ease:Power4.easeOut},peopleStartTime + 0.4);
      forkliftTl.fromTo($('#fowtr-chapter2 #fowtr-article2 .person4'),2,{scale:0.8,opacity:0},{scale:1,opacity:1,ease:Power4.easeOut},peopleStartTime + 0.6);
      forkliftTl.fromTo($('#fowtr-chapter2 #fowtr-article2 .person5'),2,{scale:0.8,opacity:0},{scale:1,opacity:1,ease:Power4.easeOut},peopleStartTime + 0.8);


      $('#fowtr-chapter2 #fowtr-article2 .forklift-animation').one('inview', {offsetTop:300}, function(event, visible) {
          if (visible) {
              // donut1tl.play(); //play once only
              forkliftTl.play(); //play each time from 0
          } else {
            // donut1tl.pause();
            // donut1tl.seek(0);
          }
      });


      var forkliftNumbersTl = new TimelineMax({paused: true});
      var num = {val: 0};

      forkliftNumbersTl.fromTo(num,2,{val:0},{val:7000,ease:Power4.easeOut,onUpdate:function(){
        $('#fowtr-chapter2 #fowtr-article2 .forklift-animation .text-line1').html((num.val).toFixed() + '+');        
      }},0);
      forkliftNumbersTl.fromTo($('#fowtr-chapter2 #fowtr-article2 .forklift-animation .text-line1'),2,{opacity:0},{opacity:1,ease:Power4.easeOut},0);
      forkliftNumbersTl.fromTo($('#fowtr-chapter2 #fowtr-article2 .forklift-animation .text-line2'),2,{opacity:0},{opacity:1,ease:Power4.easeOut},1);


      $('#fowtr-chapter2 #fowtr-article2 .forklift-animation .text').one('inview', {offsetTop:100}, function(event, visible) {
          if (visible) {
              // donut1tl.play(); //play once only
              forkliftNumbersTl.play(); //play each time from 0
          } else {
            // donut1tl.pause();
            // donut1tl.seek(0);
          }
      });





      // ------------------------------------------------------------------------------------------------------
      // article 4 svg animations
      // ------------------------------------------------------------------------------------------------------
      // -----------------------------------------------------------------------------------------------------------------------------------------
      // article4 chart1
      // -----------------------------------------------------------------------------------------------------------------------------------------

      var element = $("#fowtr-chapter2 #fowtr-article4 .inlinesvg1");
      var article4inlinesvg1classes = element.attr('class');
      fowtr_module_utilities.inlineSvg(element,function(svg){
        svg.attr('class',article4inlinesvg1classes); //put same classes on the new content
        svg.find('#people2 g').css({'opacity':0});
        svg.find('#text9').css({'opacity':0});
        svg.find('#textin').css({'opacity':0});
        svg.find('#text10').css({'opacity':0});
        $('#fowtr-chapter2 #fowtr-article4 .chart-text1').css({'opacity':0});

        var tl = new TimelineMax({paused: true});

        // grey ppl
        for (var i = 1; i < 11; i++) {
          tl.fromTo(svg.find("#people1 #p"+i),0.5,{scale:2.5,opacity:0,x:"-=20",y:"-=55"},{scale:1,opacity:1,x:"+=20",y:"+=55",delay:0.06*i},0);
        }

        tl.fromTo(svg.find("#text9"),0.5,{scale:1.5,opacity:0,x:"-=25",y:"-=25"},{scale:1,opacity:1,x:"+=25",y:"+=25",delay:0.06*i},1);
        tl.fromTo(svg.find("#textin"),0.5,{scale:1.5,opacity:0,x:"-=25",y:"-=25"},{scale:1,opacity:1,x:"+=25",y:"+=25",delay:0.06*i},1.2);
        tl.fromTo(svg.find("#text10"),0.5,{scale:1.5,opacity:0,x:"-=25",y:"-=25"},{scale:1,opacity:1,x:"+=25",y:"+=25",delay:0.06*i},1.4);

        for (var i = 1; i < 10; i++) {
          tl.fromTo(svg.find("#people2 #p"+i+'-2'),0.5,{opacity:0},{opacity:1,delay:0.06*i},1);
          tl.to(svg.find("#people1 #p"+i),0.5,{opacity:0,delay:0.06*i},1);
          // tl.fromTo(svg.find("#people1 #p"+i),0.5,{scale:2.5,opacity:0,x:"-=20",y:"-=55"},{scale:1,opacity:1,x:"+=20",y:"+=55",delay:0.06*i},0);
        }

        tl.to($('#fowtr-chapter2 #fowtr-article4 .chart-text1'),0.5,{opacity:1},2);

        // inview - trigger play when in view
        svg.one('inview', {triggerTop:'bottom', triggerBottom:'top', offsetTop:0}, function(event, visible) {
            if (visible) {
                tl.play(); //play once only
                // tl.play(0); //play each time from 0
            } else {
              // tl.pause();
              // tl.seek(0);
            }
        });
      });


      // -----------------------------------------------------------------------------------------------------------------------------------------
      // article4 chart2
      // -----------------------------------------------------------------------------------------------------------------------------------------

      var element = $("#fowtr-chapter2 #fowtr-article4 .inlinesvg2");
      var article4inlinesvg2classes = element.attr('class');
      fowtr_module_utilities.inlineSvg(element,function(svg){
        svg.attr('class',article4inlinesvg2classes); //put same classes on the new content
        
        svg.find('#hands2 g').css({'opacity':0});
        svg.find('#text9').css({'opacity':0});
        svg.find('#textin').css({'opacity':0});
        svg.find('#text10').css({'opacity':0});
        $('#fowtr-chapter2 #fowtr-article4 .chart-text2').css({'opacity':0});

        var tl = new TimelineMax({paused: true});
        var delay = 0.5;

        // grey ppl
        for (var i = 1; i < 11; i++) {
          tl.fromTo(svg.find("#hands1 #h"+i),0.5,{scale:2.5,opacity:0,x:"-=20",y:"-=55"},{scale:1,opacity:1,x:"+=20",y:"+=55",delay:0.06*i},0+delay);
        }

        tl.fromTo(svg.find("#text9"),0.5,{scale:1.5,opacity:0,x:"-=25",y:"-=25"},{scale:1,opacity:1,x:"+=25",y:"+=25",delay:0.06*i},1+delay);
        tl.fromTo(svg.find("#textin"),0.5,{scale:1.5,opacity:0,x:"-=25",y:"-=25"},{scale:1,opacity:1,x:"+=25",y:"+=25",delay:0.06*i},1.2+delay);
        tl.fromTo(svg.find("#text10"),0.5,{scale:1.5,opacity:0,x:"-=25",y:"-=25"},{scale:1,opacity:1,x:"+=25",y:"+=25",delay:0.06*i},1.4+delay);

        for (var i = 1; i < 10; i++) {
          tl.fromTo(svg.find("#hands2 #h"+i+'-2'),0.5,{opacity:0},{opacity:1,delay:0.06*i},1+delay);
          tl.to(svg.find("#hands1 #h"+i),0.5,{opacity:0,delay:0.06*i},1+delay);
          // tl.fromTo(svg.find("#people1 #p"+i),0.5,{scale:2.5,opacity:0,x:"-=20",y:"-=55"},{scale:1,opacity:1,x:"+=20",y:"+=55",delay:0.06*i},0);
        }

        tl.to($('#fowtr-chapter2 #fowtr-article4 .chart-text2'),0.5,{opacity:1},2+delay);

        // inview - trigger play when in view
        svg.one('inview', {triggerTop:'bottom', triggerBottom:'top', offsetTop:0}, function(event, visible) {
            if (visible) {
                tl.play(); //play once only
                // tl.play(0); //play each time from 0
            } else {
              // tl.pause();
              // tl.seek(0);
            }
        });
      });




      // ------------------------------------------------------------------------------------------------------
      // article 5 svg animations
      // ------------------------------------------------------------------------------------------------------
     
      // -----------------------------------------------------------------------------------------------------------------------------------------
      // donut1
      // -----------------------------------------------------------------------------------------------------------------------------------------
      // var anglePI = (35) * (Math.PI / 180);
      // var angleCoords = {
      //     'x1': Math.round(50 + Math.sin(anglePI) * 50) + '%',
      //     'y1': Math.round(50 + Math.cos(anglePI) * 50) + '%',
      //     'x2': Math.round(50 + Math.sin(anglePI + Math.PI) * 50) + '%',
      //     'y2': Math.round(50 + Math.cos(anglePI + Math.PI) * 50) + '%',
      // }
      // var str = 'x1="'+angleCoords.x1+'" y1="'+angleCoords.y1+'" x1="'+angleCoords.x2+'" y2="'+angleCoords.y2+'"';
      // console.log('angle',str);



      function easeInOutQuad(t, b, c, d) {
        if ((t/=d/2) < 1) return c/2*t*t + b;
        return -c/2 * ((--t)*(t-2) - 1) + b;
      }
      function easeInOutQuart(t, b, c, d) {
        if ((t/=d/2) < 1) return c/2*t*t*t*t + b;
        return -c/2 * ((t-=2)*t*t*t - 2) + b;
      }

      $('#fowtr-chapter2 #fowtr-article5 .donut1 .donut-percent, #fowtr-chapter2 #fowtr-article5 .chart-text1').css({'opacity':0});
      $('#fowtr-chapter2 #fowtr-article5 .donut1 .donut-ring').css({'transform-origin':'center','opacity':0});

      var donut1tl = new TimelineMax({paused: true});
      donut1tl.fromTo($('#fowtr-chapter2 #fowtr-article5 .donut1 .donut-ring'),1,{opacity:0.1},{opacity:1,ease:Linear.easeNone},0);
      donut1tl.fromTo($('#fowtr-chapter2 #fowtr-article5 .donut1 .donut-segment'),2,{strokeDasharray:'0,100'},{strokeDasharray:'58,42',ease:Power4.easeInOut, onUpdate:donut1text},0.5);
      donut1tl.fromTo($('#fowtr-chapter2 #fowtr-article5 .donut1 .donut-percent'),2,{opacity:0},{opacity:1},0.5);

      //color
      // donut1tl.fromTo($('#fowtr-chapter2 #fowtr-article5 .donut1 .donut-segment'),1,{stroke:'#ffcc00'},{stroke:'#d40511'},1.5);
      donut1tl.fromTo($('#fowtr-chapter2 #fowtr-article5 .donut1 .donut-percent'),1,{fill:'#ffcc00'},{fill:'#d40511'},1.5);

      function donut1text(){
        // console.log('this',this);
        // var percent = (this.progress() * 58).toFixed();
        var percent = easeInOutQuart(this.progress(),0,58,1).toFixed();
        $('#fowtr-chapter2 #fowtr-article5 .donut1 .donut-percent').html(percent+"%");

      }
      donut1tl.fromTo($('#fowtr-chapter2 #fowtr-article5 .chart-text1'),0.5,{opacity:0},{opacity:1},1.5);


      $('#fowtr-chapter2 #fowtr-article5 .donut1').one('inview', {triggerTop:'middle', triggerBottom:'top', offsetTop:0}, function(event, visible) {
          if (visible) {
              donut1tl.play(); //play once only
              // donut1tl.play(0); //play each time from 0
          } else {
            // donut1tl.pause();
            // donut1tl.seek(0);
          }
      });


      // -----------------------------------------------------------------------------------------------------------------------------------------
      // donut2
      // -----------------------------------------------------------------------------------------------------------------------------------------


      $('#fowtr-chapter2 #fowtr-article5 .donut2 .donut-percent, #fowtr-chapter2 #fowtr-article5 .chart-text2').css({'opacity':0});
      $('#fowtr-chapter2 #fowtr-article5 .donut2 .donut-ring').css({'transform-origin':'center','opacity':0});
      var donut2delay = 0.3;

      var donut2tl = new TimelineMax({paused: true});
      donut2tl.fromTo($('#fowtr-chapter2 #fowtr-article5 .donut2 .donut-ring'),1,{opacity:0.1},{opacity:1,ease:Linear.easeNone},0+donut2delay);
      donut2tl.fromTo($('#fowtr-chapter2 #fowtr-article5 .donut2 .donut-segment'),2,{strokeDasharray:'0,100'},{strokeDasharray:'52,48',ease:Power4.easeInOut, onUpdate:donut2text},0.5+donut2delay);
      donut2tl.fromTo($('#fowtr-chapter2 #fowtr-article5 .donut2 .donut-percent'),2,{opacity:0},{opacity:1},0.5+donut2delay);
      function donut2text(){
        // console.log('this',this);
        // var percent = (this.progress() * 58).toFixed();
        var percent = easeInOutQuart(this.progress(),0,52,1).toFixed();
        $('#fowtr-chapter2 #fowtr-article5 .donut2 .donut-percent').html(percent+"%");

      }
      donut2tl.fromTo($('#fowtr-chapter2 #fowtr-article5 .chart-text2'),0.5,{opacity:0},{opacity:1},1.5+donut2delay);


      $('#fowtr-chapter2 #fowtr-article5 .donut2').one('inview', {triggerTop:'middle', triggerBottom:'top', offsetTop:0}, function(event, visible) {
          if (visible) {
              donut2tl.play(); //play once only
              // donut2tl.play(0); //play each time from 0
          } else {
            // donut2tl.pause();
            // donut2tl.seek(0);
          }
      });










      // ------------------------------------------------------------------------------------------------------
      // article 6 world map
      // ------------------------------------------------------------------------------------------------------

      var mapDataOperations = [
        {
          "title":"USA &amp; Canada",
          // "values":[30,33,17,16,4],
          "values":[63,17,20],
          "arrow_position": "left"
        },
        {
          "title":"Latin America &amp; the Caribbean",
          // "values":[25,27,22,15,9],
          "values":[52,22,24],
          "arrow_position": "left"
        },
        {
          "title":"Europe",
          // "values":[32,29,19,10,7],
          "values":[61,19,17],
          "arrow_position": "bottom"
        },
        {
          "title":"Sub-Saharan Africa",
          // "values":[16,31,40,7,2],
          "values":[47,40,9],
          "arrow_position": "bottom"
        },
        {
          "title":"Middle East & North Africa",
          // "values":[25,30,19,10,14],
          "values":[55,19,24],
          "arrow_position": "bottom"
        },
        {
          "title":"Central & South Asia",
          // "values":[25,31,28,11,4],
          "values":[56,28,15],
          "arrow_position": "bottom"
        },
        {
          "title":"Southeast Asia",
          // "values":[31,26,18,14,6],
          "values":[57,18,20],
          "arrow_position": "right"
        },
        {
          "title":"East Asia",
          // "values":[42,28,12,7,9],
          "values":[70,12,16],
          "arrow_position": "right"
        },
        {
          "title":"Oceania",
          // "values":[19,28,28,16,6],
          "values":[47,28,22],
          "arrow_position": "right"
        },
      ];
      var mapDataOffice = [
        {
          "title":"USA &amp; Canada",
          "values":[72,14,12],
          "arrow_position": "left"
        },
        {
          "title":"Latin America &amp; the Caribbean",
          "values":[43,20,35],
          "arrow_position": "left"
        },
        {
          "title":"Europe",
          "values":[34,20,42],
          "arrow_position": "bottom"
        },
        {
          "title":"Sub-Saharan Africa",
          "values":[45,31,20],
          "arrow_position": "bottom"
        },
        {
          "title":"Middle East & North Africa",
          "values":[55,21,21],
          "arrow_position": "bottom"
        },
        {
          "title":"Central & South Asia",
          "values":[56,17,24],
          "arrow_position": "bottom"
        },
        {
          "title":"Southeast Asia",
          "values":[37,21,37],
          "arrow_position": "right"
        },
        {
          "title":"East Asia",
          "values":[48,19,33],
          "arrow_position": "right"
        },
        {
          "title":"Oceania",
          "values":[31,26,42],
          "arrow_position": "right"
        },
      ];
      var mapData = mapDataOperations;


      var mapNodePopup = $('#fowtr-chapter2 #fowtr-article6 .technical-advancements-threat-world-map .map-node-popup');
      var category = 'Operations';


      function openPopup(id){
        var data = mapData[id-1];

        // position
        var node = $('#fowtr-chapter2 #fowtr-article6 .technical-advancements-threat-world-map .map-node[data-node-id="'+id+'"]');
        // var nodeRect = node[0].getBoundingClientRect();
        var mapRect = $('#fowtr-chapter2 #fowtr-article6 .technical-advancements-threat-world-map .map')[0].getBoundingClientRect();
        var nodeOffsetTop = (node.position().top / mapRect.height) * 100;
        var nodeOffsetLeft = (node.position().left / mapRect.width) * 100;
        var adjustment = 0;
        if(node.outerWidth()>30) adjustment = 0.15;
        var nodePosition;

        gsap.killTweensOf("#fowtr-chapter2 #fowtr-article6 .technical-advancements-threat-world-map .map-node-popup");

        // nodeOffsetTop = nodeOffsetTop-190; // height of the popup including down arrow
        // nodeOffsetLeft = nodeOffsetLeft-150; // 1/2 width of the popup

        // align top left corner of popup to node center
        mapNodePopup.css({'top':nodeOffsetTop+'%','left':nodeOffsetLeft+'%'});

        // set attr so we can add triangle with css - also set position var here
        mapNodePopup.removeAttr('data-popup-position');
        if($(window).width()<700) {
          nodePosition = 'none';
          // for css
          mapNodePopup.attr('data-popup-position','none');
          // data.arrow_position = "none";
        } else {
          nodePosition = data.arrow_position;
          // for css
          mapNodePopup.attr('data-popup-position',data.arrow_position);
        }


        // change to top if off top of screen
        var popupPosition = mapNodePopup[0].getBoundingClientRect();
        if(nodePosition == "bottom" && (mapRect.top + node.position().top - (120+30))<105){ //allow 105 for header, (160+30) for the height of the popup
          nodePosition = "top";
          mapNodePopup.attr('data-popup-position','top');
        } else {
          nodePosition == "bottom";
        }


        // for positioning margin offset so arrow is at point
        if(nodePosition=='left'){
          mapNodePopup.css({'margin-top':"-79px",'margin-left':"30px"});
        } else if(nodePosition=='right'){
          mapNodePopup.css({'margin-top':"-79px",'margin-left':"-270px"});
        } else if(nodePosition=='bottom'){
          mapNodePopup.css({'margin-top':"-190px",'margin-left':"-120px"});
        } else if(nodePosition=='top'){
          mapNodePopup.css({'margin-top':"30px",'margin-left':"-120px"});
        }

        // mobile - centered on screen
        if($(window).width()<700) {
          mapNodePopup.css({'margin-top':"0px",'margin-left':"-120px","top":"20%","left":"50%"});
        }

        // reset opacities
        mapNodePopup.find('.bar').css('height',0);
        mapNodePopup.find('.bar span').css('opacity',0);
        mapNodePopup.find('.popup-title').css('opacity',0);

        // tween from arrow point method
        mapNodePopup.show();
        var popupSpeed = 0.3;
        if(nodePosition=='left'){
          TweenMax.fromTo(mapNodePopup,popupSpeed,{opacity:0,x:-(240/2)-30,y:0,scale:0},{opacity:1,x:0,y:0,scale:1,ease:Power4.easeOut});
        } else if(nodePosition=='right'){
          TweenMax.fromTo(mapNodePopup,popupSpeed,{opacity:0,x:(240/2)+30,y:0,scale:0},{opacity:1,x:0,y:0,scale:1,ease:Power4.easeOut});
        } else if(nodePosition=='bottom'){
          TweenMax.fromTo(mapNodePopup,popupSpeed,{opacity:0,x:0,y:(160/2)+30,scale:0},{opacity:1,x:0,y:0,scale:1,ease:Power4.easeOut});
        } else if(nodePosition=='none'){
          TweenMax.fromTo(mapNodePopup,popupSpeed,{opacity:0,x:0,y:0,scale:0},{opacity:1,x:0,y:0,scale:1,ease:Power4.easeOut});
        } else if(nodePosition=='top'){
          TweenMax.fromTo(mapNodePopup,popupSpeed,{opacity:0,x:0,y:-(160/2)-30,scale:0},{opacity:1,x:0,y:0,scale:1,ease:Power4.easeOut});
        }


        // mapNodePopup.fadeIn('fast',function(){
          // content
          // var high = Math.max.apply(null, data.values);
          // var ratio = high / 80; //80% is effectively tallest
          var ratio = 70 / 80; //42 is highest, so that is 80% tallest
          gsap.killTweensOf("#fowtr-chapter2 #fowtr-article6 .technical-advancements-threat-world-map .map-node-popup .popup-title");
          gsap.killTweensOf("#fowtr-chapter2 #fowtr-article6 .technical-advancements-threat-world-map .map-node-popup .bar");
          gsap.killTweensOf("#fowtr-chapter2 #fowtr-article6 .technical-advancements-threat-world-map .map-node-popup .bars span");
          var delay = 0.2;
          for (var i = 0; i < data.values.length; i++) {
            var height = data.values[i] / ratio;
            mapNodePopup.find('.bar'+(i+1)+' span').html(data.values[i]+'%');
            TweenMax.fromTo(mapNodePopup.find('.bar'+(i+1)+' .bar'),0.5,{height:0},{height:height+'%',ease:Power2.easeOut,delay:delay+0.05*i});
            TweenMax.fromTo(mapNodePopup.find('.bar'+(i+1)+' span'),0.5,{opacity:0},{opacity:1,ease:Power2.easeOut,delay:delay+0.2+(0.05*i)});
          }
          // mapNodePopup.find('.popup-title').html(data.title + ' <span class="popup-category"> - '+category+'</span>');
          mapNodePopup.find('.popup-title').html(data.title);
          TweenMax.fromTo(mapNodePopup.find('.popup-title'),0.2,{opacity:0},{opacity:1,ease:Linear.easeNone,delay:delay+0});
        // });



      }

      function closePopup(){
        TweenMax.to(mapNodePopup,0.5,{opacity:0,onComplete:function(){ mapNodePopup.css('display','none'); }});
      }

      // click
      $('#fowtr-chapter2 #fowtr-article6 .technical-advancements-threat-world-map').on('click', '.map-node', function(event) {
        event.preventDefault();
        var id = $(this).attr('data-node-id');
        openPopup(id);
      });
      // close click
      $('#fowtr-chapter2 #fowtr-article6 .technical-advancements-threat-world-map').on('click', '.map-node-popup-close', function(event) {
        event.preventDefault();
        closePopup();
        // mapNodePopup.fadeOut('fast');
        // TweenMax.to(mapNodePopup,0.5,{opacity:0,onComplete:function(){ mapNodePopup.css('display','none'); }});
      });


      // hover
      // mapNodePopup.css('pointer-events','none');
      $('#fowtr-chapter2 #fowtr-article6 .technical-advancements-threat-world-map').on('mouseover', '.map-node', function(event) {
        if($(window).width()<700) {
          mapNodePopup.css('pointer-events','auto');
          return;
        } else {
          mapNodePopup.css('pointer-events','none');
        }
        var id = $(this).attr('data-node-id');
        openPopup(id);
      });
      $('#fowtr-chapter2 #fowtr-article6 .technical-advancements-threat-world-map').on('mouseout', '.map-node', function(event) {
        if($(window).width()<700) {
          mapNodePopup.css('pointer-events','auto');
          return;
        } else {
          mapNodePopup.css('pointer-events','none');
        }
        var id = $(this).attr('data-node-id');
        // mapNodePopup.fadeOut('fast');
        // TweenMax.to(mapNodePopup,0.5,{opacity:0,onComplete:function(){ mapNodePopup.css('display','none'); }});
        closePopup();
      });




      // operations / office switcher
      $('#fowtr-chapter2 #fowtr-article6 .chart-selector').on('click', '.selector', function(event) {
        event.preventDefault();
        closePopup();
        $('#fowtr-chapter2 #fowtr-article6 .selector').removeClass('active');
        if($(this).hasClass('selector1')){
          // state1();
          category = 'Operations';
          mapData = mapDataOperations;
          $('#fowtr-chapter2 #fowtr-article6 .selector1').addClass('active');
        } else {
          // state2();
          category = 'Office';
          mapData = mapDataOffice;
          $('#fowtr-chapter2 #fowtr-article6 .selector2').addClass('active');
        }
        // fade out and in
        var h5 = $('#fowtr-chapter2 #fowtr-article6 .technical-advancements-threat-world-map h5');
        h5.stop().fadeOut('fast',function(){
          h5.html(category);
          h5.fadeIn('slow');
        });

        // TweenMax.to($('#fowtr-chapter2 #fowtr-article6 .technical-advancements-threat-world-map .map-node'),1,{opacity:0,scale:0,ease:Power4.easeIn,onComplete:function(){
        //   TweenMax.to($('#fowtr-chapter2 #fowtr-article6 .technical-advancements-threat-world-map .map-node'),1,{opacity:1,scale:1,ease:Power4.easeOut});          
        // }});
       
        // var sp = 0.1;
        //   TweenMax.to($('#fowtr-chapter2 #fowtr-article6 .technical-advancements-threat-world-map .map-node'),0.03,{opacity:0,scale:1,ease:Linear.easeNone});          
        //   // TweenMax.to($('#fowtr-chapter2 #fowtr-article6 .technical-advancements-threat-world-map .map-node'),sp,{opacity:1,scale:1,delay:sp,ease:Power4.easeIn});
        //   $.each($('#fowtr-chapter2 #fowtr-article6 .technical-advancements-threat-world-map .map-node'), function(index, val) {
        //     TweenMax.to($(this),0.2,{opacity:1,scale:1,delay:0.06+(0.02*index),ease:Power4.easeIn});        
        //   });
        // TweenMax.fromTo($('#fowtr-chapter2 #fowtr-article6 .technical-advancements-threat-world-map .map-node'),0.5,{css:{'transform':'scale(1.4)','transition':'none'}},{css:{'transform':'scale(1)','transition':'transform 100ms ease-in-out'},ease:Power4.easeOut});  
        // TweenMax.fromTo($('#fowtr-chapter2 #fowtr-article6 .technical-advancements-threat-world-map .map-node'),0.3,{scale:2},{scale:1,ease:Power4.easeOut});  
        $.each($('#fowtr-chapter2 #fowtr-article6 .technical-advancements-threat-world-map .map-node'), function(index, val) {
          TweenMax.fromTo($(this),0.4,{opacity:0},{opacity:1,delay:0.08+(0.03*index),ease:Linear.easeNone});        
        });     

      });

      if(!fowtr_module_utilities.isMobile){
        $('#fowtr-chapter2 #fowtr-article6 .chart-selector .selector1').data('powertip', 'Operations').powerTip();
        $('#fowtr-chapter2 #fowtr-article6 .chart-selector .selector2').data('powertip', 'Office').powerTip();
      }





      // ------------------------------------------------------------------------------------------------------
      // article 7 svg chart
      // ------------------------------------------------------------------------------------------------------
      var element = $("#fowtr-chapter2 #fowtr-article7 .inlinesvg");
      var article7classes = element.attr('class');
      fowtr_module_utilities.inlineSvg(element,function(svg){
        svg.attr('class',article7classes); //put same classes on the new content

        // animation
        var tl = new TimelineMax({paused: true});

        var stagger,speed,delay;

        speed = 0.5;
        tl.fromTo(svg.find('#xaxis'),speed,{autoAlpha:0,y:"+20px"},{autoAlpha:1,y:0,ease:Power4.easeOut,delay:0},0);
        tl.fromTo(svg.find('#yaxis'),speed,{autoAlpha:0,x:"-20px"},{autoAlpha:1,x:0,ease:Power4.easeOut,delay:0},0);
        tl.fromTo(svg.find('#legend'),speed,{autoAlpha:0,y:"+20px"},{autoAlpha:1,y:0,ease:Power4.easeOut,delay:0},0.2);
        tl.fromTo(svg.find('#grid'),speed,{autoAlpha:0},{autoAlpha:1,delay:0},0);

        stagger = 0.1;
        delay = 0.5;
        speed = 1;
        tl.fromTo(svg.find('#bar1'),speed,{css:{height:0,y:270.92}},{css:{height:270.92,y:0},ease:Power4.easeInOut,delay:delay+stagger*0},0);
        tl.fromTo(svg.find('#bar2'),speed,{css:{height:0,y:308.69}},{css:{height:308.69,y:0},ease:Power4.easeInOut,delay:delay+stagger*1},0);
        tl.fromTo(svg.find('#bar3'),speed,{css:{height:0,y:303.01}},{css:{height:303.01,y:0},ease:Power4.easeInOut,delay:delay+stagger*2},0);
        tl.fromTo(svg.find('#bar4'),speed,{css:{height:0,y:278.58}},{css:{height:278.58,y:0},ease:Power4.easeInOut,delay:delay+stagger*3},0);
        tl.fromTo(svg.find('#bar5'),speed,{css:{height:0,y:210.58}},{css:{height:210.58,y:0},ease:Power4.easeInOut,delay:delay+stagger*4},0);
        tl.fromTo(svg.find('#bar6'),speed,{css:{height:0,y:164.5}},{css:{height:164.5,y:0},ease:Power4.easeInOut,delay:delay+stagger*5},0);
        tl.fromTo(svg.find('#bar7'),speed,{css:{height:0,y:296.99}},{css:{height:296.99,y:0},ease:Power4.easeInOut,delay:delay+stagger*6},0);
        tl.fromTo(svg.find('#bar8'),speed,{css:{height:0,y:140.51}},{css:{height:140.51,y:0},ease:Power4.easeInOut,delay:delay+stagger*7},0);
        


        var options = {
          intentPollInterval:20,
          followMouse:true,
          fadeInTime:0,
          fadeOutTime:0,
          // openEvents:['mouseover','focus']
          // closeDelay:0
        }
        svg.find('#bar1').data('powertip', '58% of people in operations, under 25').powerTip(options);
        svg.find('#bar2').data('powertip', '66% of people in office, under 25').powerTip(options);
        svg.find('#bar3').data('powertip', '64% of people in operations, 25-39').powerTip(options);
        svg.find('#bar4').data('powertip', '60% of people in office, 25-39').powerTip(options);
        svg.find('#bar5').data('powertip', '46% of people in operations, 40-54').powerTip(options);
        svg.find('#bar6').data('powertip', '36% of people in office, 40-54').powerTip(options);
        svg.find('#bar7').data('powertip', '63% of people in operations, 55 and above').powerTip(options);
        svg.find('#bar8').data('powertip', '29% of people in office, 55 and above').powerTip(options);



        // inview - trigger play when in view
        svg.one('inview', {offsetTop:200}, function(event, visible) {
            if (visible) {
                tl.play(); //play once only
                // tl.play(0); //play each time from 0
            } else {
              // tl.pause();
              // tl.seek(0);
            }
        });
      });






      // ------------------------------------------------------------------------------------------------------
      // article 9 svg chart
      // ------------------------------------------------------------------------------------------------------
      var element = $("#fowtr-chapter2 #fowtr-article9 .inlinesvg");
      var article9classes = element.attr('class');
      fowtr_module_utilities.inlineSvg(element,function(svg){
        svg.attr('class',article9classes); //put same classes on the new content

        // svg.find('rect').css({'transform-box':'fill-box','transform-origin':'100%'});

        // animation
        var tl = new TimelineMax({paused: true});

        var stagger,speed,delay;

        speed = 0.5;
        tl.fromTo(svg.find('#xaxis'),speed,{autoAlpha:0,y:"+20px"},{autoAlpha:1,y:0,ease:Power4.easeOut,delay:0},0);
        tl.fromTo(svg.find('#yaxis'),speed,{autoAlpha:0,x:"-20px"},{autoAlpha:1,x:0,ease:Power4.easeOut,delay:0},0);
        tl.fromTo(svg.find('#legend'),speed,{autoAlpha:0,y:"+20px"},{autoAlpha:1,y:0,ease:Power4.easeOut,delay:0},0.2);
        tl.fromTo(svg.find('#grid'),speed,{autoAlpha:0},{autoAlpha:1,delay:0},0);

        stagger = 0.1;
        delay = 0.5;
        speed = 1;

        tl.from(svg.find('#bar1s1'),speed,{attr:{height:0,y:466.0457},ease:Power4.easeInOut,delay:delay+stagger*0},0);
        tl.from(svg.find('#bar1s2'),speed,{attr:{height:0,y:466.0457},ease:Power4.easeInOut,delay:delay+stagger*0},0);
        tl.from(svg.find('#bar1s3'),speed,{attr:{height:0,y:466.0457},ease:Power4.easeInOut,delay:delay+stagger*0},0);

        delay += 0.1;
        tl.from(svg.find('#bar2s1'),speed,{attr:{height:0,y:466.0457},ease:Power4.easeInOut,delay:delay+stagger*0},0);
        tl.from(svg.find('#bar2s2'),speed,{attr:{height:0,y:466.0457},ease:Power4.easeInOut,delay:delay+stagger*0},0);
        tl.from(svg.find('#bar2s3'),speed,{attr:{height:0,y:466.0457},ease:Power4.easeInOut,delay:delay+stagger*0},0);

        delay += 0.1;
        tl.from(svg.find('#bar3s1'),speed,{attr:{height:0,y:466.0457},ease:Power4.easeInOut,delay:delay+stagger*0},0);
        tl.from(svg.find('#bar3s2'),speed,{attr:{height:0,y:466.0457},ease:Power4.easeInOut,delay:delay+stagger*0},0);
        tl.from(svg.find('#bar3s3'),speed,{attr:{height:0,y:466.0457},ease:Power4.easeInOut,delay:delay+stagger*0},0);

        delay += 0.1;
        tl.from(svg.find('#bar4s1'),speed,{attr:{height:0,y:466.0457},ease:Power4.easeInOut,delay:delay+stagger*0},0);
        tl.from(svg.find('#bar4s2'),speed,{attr:{height:0,y:466.0457},ease:Power4.easeInOut,delay:delay+stagger*0},0);
        tl.from(svg.find('#bar4s3'),speed,{attr:{height:0,y:466.0457},ease:Power4.easeInOut,delay:delay+stagger*0},0);
      
        delay += 0.1;
        tl.from(svg.find('#bar5s1'),speed,{attr:{height:0,y:466.0457},ease:Power4.easeInOut,delay:delay+stagger*0},0);
        tl.from(svg.find('#bar5s2'),speed,{attr:{height:0,y:466.0457},ease:Power4.easeInOut,delay:delay+stagger*0},0);
        tl.from(svg.find('#bar5s3'),speed,{attr:{height:0,y:466.0457},ease:Power4.easeInOut,delay:delay+stagger*0},0);
      
        delay += 0.1;
        tl.from(svg.find('#bar6s1'),speed,{attr:{height:0,y:466.0457},ease:Power4.easeInOut,delay:delay+stagger*0},0);
        tl.from(svg.find('#bar6s2'),speed,{attr:{height:0,y:466.0457},ease:Power4.easeInOut,delay:delay+stagger*0},0);
        tl.from(svg.find('#bar6s3'),speed,{attr:{height:0,y:466.0457},ease:Power4.easeInOut,delay:delay+stagger*0},0);

        delay += 0.1;
        tl.from(svg.find('#bar7s1'),speed,{attr:{height:0,y:466.0457},ease:Power4.easeInOut,delay:delay+stagger*0},0);
        tl.from(svg.find('#bar7s2'),speed,{attr:{height:0,y:466.0457},ease:Power4.easeInOut,delay:delay+stagger*0},0);
        tl.from(svg.find('#bar7s3'),speed,{attr:{height:0,y:466.0457},ease:Power4.easeInOut,delay:delay+stagger*0},0);


        delay += 0.1;
        tl.from(svg.find('#bar8s1'),speed,{attr:{height:0,y:466.0457},ease:Power4.easeInOut,delay:delay+stagger*0},0);
        tl.from(svg.find('#bar8s2'),speed,{attr:{height:0,y:466.0457},ease:Power4.easeInOut,delay:delay+stagger*0},0);
        tl.from(svg.find('#bar8s3'),speed,{attr:{height:0,y:466.0457},ease:Power4.easeInOut,delay:delay+stagger*0},0);

        delay += 0.1;
        tl.from(svg.find('#bar9s1'),speed,{attr:{height:0,y:466.0457},ease:Power4.easeInOut,delay:delay+stagger*0},0);
        tl.from(svg.find('#bar9s2'),speed,{attr:{height:0,y:466.0457},ease:Power4.easeInOut,delay:delay+stagger*0},0);
        tl.from(svg.find('#bar9s3'),speed,{attr:{height:0,y:466.0457},ease:Power4.easeInOut,delay:delay+stagger*0},0);


        delay += 0.1;
        tl.from(svg.find('#bar10s1'),speed,{attr:{height:0,y:466.0457},ease:Power4.easeInOut,delay:delay+stagger*0},0);
        tl.from(svg.find('#bar10s2'),speed,{attr:{height:0,y:466.0457},ease:Power4.easeInOut,delay:delay+stagger*0},0);
        tl.from(svg.find('#bar10s3'),speed,{attr:{height:0,y:466.0457},ease:Power4.easeInOut,delay:delay+stagger*0},0);


        delay = 0.5;
        tl.to($('#fowtr-chapter2 #fowtr-article9 .chart-title1-state1'),0.5,{autoAlpha:1,ease:Linear.easeNone,delay:delay},0);
        tl.to($('#fowtr-chapter2 #fowtr-article9 .chart-title2-state1'),0.5,{autoAlpha:1,ease:Linear.easeNone,delay:delay},0);
        tl.to($('#fowtr-chapter2 #fowtr-article9 .chart-selector-wrapper'),0.5,{autoAlpha:1,ease:Linear.easeNone,delay:delay},0);





        function state1(){

          speed = 1;

          TweenMax.to(svg.find('#bar1s1'),speed,{attr:{height:9.6491,y:4.87},ease:Power4.easeInOut});
          TweenMax.to(svg.find('#bar1s2'),speed,{attr:{height:50.4503,y:14.5198},ease:Power4.easeInOut});
          TweenMax.to(svg.find('#bar1s3'),speed,{attr:{height:401.1608,y:64.9701},ease:Power4.easeInOut});

          TweenMax.to(svg.find('#bar2s1'),speed,{attr:{height:5.2783,y:4.8707},ease:Power4.easeInOut});
          TweenMax.to(svg.find('#bar2s2'),speed,{attr:{height:45.7177,y:10.149},ease:Power4.easeInOut});
          TweenMax.to(svg.find('#bar2s3'),speed,{attr:{height:410.2642,y:55.8667},ease:Power4.easeInOut});

          TweenMax.to(svg.find('#bar3s1'),speed,{attr:{height:5.2515,y:4.8707},ease:Power4.easeInOut});
          TweenMax.to(svg.find('#bar3s2'),speed,{attr:{height:26.2887,y:10.1223},ease:Power4.easeInOut});
          TweenMax.to(svg.find('#bar3s3'),speed,{attr:{height:429.72,y:36.411},ease:Power4.easeInOut});

          TweenMax.to(svg.find('#bar4s1'),speed,{attr:{height:11.0433,y:4.8707},ease:Power4.easeInOut});
          TweenMax.to(svg.find('#bar4s2'),speed,{attr:{height:42.415,y:15.914},ease:Power4.easeInOut});
          TweenMax.to(svg.find('#bar4s3'),speed,{attr:{height:407.8019,y:58.329},ease:Power4.easeInOut});

          TweenMax.to(svg.find('#bar5s1'),speed,{attr:{height:5.4986,y:4.8707},ease:Power4.easeInOut});
          TweenMax.to(svg.find('#bar5s2'),speed,{attr:{height:73.9506,y:10.3694},ease:Power4.easeInOut});
          TweenMax.to(svg.find('#bar5s3'),speed,{attr:{height:381.8109,y:84.32},ease:Power4.easeInOut});

          TweenMax.to(svg.find('#bar6s1'),speed,{attr:{height:17.0326,y:4.8707},ease:Power4.easeInOut});
          TweenMax.to(svg.find('#bar6s2'),speed,{attr:{height:118.8519,y:21.9033},ease:Power4.easeInOut});
          TweenMax.to(svg.find('#bar6s3'),speed,{attr:{height:325.3758,y:140.7552},ease:Power4.easeInOut});

          TweenMax.to(svg.find('#bar7s1'),speed,{attr:{height:17.1526,y:4.8707},ease:Power4.easeInOut});
          TweenMax.to(svg.find('#bar7s2'),speed,{attr:{height:92.1633,y:22.0697},ease:Power4.easeInOut});
          TweenMax.to(svg.find('#bar7s3'),speed,{attr:{height:351.8979,y:114.233},ease:Power4.easeInOut});

          TweenMax.to(svg.find('#bar8s1'),speed,{attr:{height:16.1928,y:4.8707},ease:Power4.easeInOut});
          TweenMax.to(svg.find('#bar8s2'),speed,{attr:{height:51.0077,y:21.0635},ease:Power4.easeInOut});
          TweenMax.to(svg.find('#bar8s3'),speed,{attr:{height:394.0597,y:72.0712},ease:Power4.easeInOut});

          TweenMax.to(svg.find('#bar9s1'),speed,{attr:{height:16.4876,y:4.8707},ease:Power4.easeInOut});
          TweenMax.to(svg.find('#bar9s2'),speed,{attr:{height:24.9406,y:21.191},ease:Power4.easeInOut});
          TweenMax.to(svg.find('#bar9s3'),speed,{attr:{height:419.9993,y:46.1316},ease:Power4.easeInOut});

          TweenMax.to(svg.find('#bar10s1'),speed,{attr:{height:5.121,y:4.8707},ease:Power4.easeInOut});
          TweenMax.to(svg.find('#bar10s2'),speed,{attr:{height:32.5173,y:9.9918},ease:Power4.easeInOut});
          TweenMax.to(svg.find('#bar10s3'),speed,{attr:{height:423.6218,y:42.5091},ease:Power4.easeInOut});


          $('#fowtr-chapter2 #fowtr-article9 .chart-title1-state2').fadeOut(function(){
            $('#fowtr-chapter2 #fowtr-article9 .chart-title1-state1').fadeIn();
          });

          $('#fowtr-chapter2 #fowtr-article9 .chart-title2-state2').fadeOut(function(){
            $('#fowtr-chapter2 #fowtr-article9 .chart-title2-state1').fadeIn();
          });

        }



        function state2(){
          
          speed = 1;

          TweenMax.to(svg.find('#bar1s1'),speed,{attr:{height:16.4499,y:4.87},ease:Power4.easeInOut});
          TweenMax.to(svg.find('#bar1s2'),speed,{attr:{height:46.1701,y:21.3206},ease:Power4.easeInOut});
          TweenMax.to(svg.find('#bar1s3'),speed,{attr:{height:398.6402,y:67.4907},ease:Power4.easeInOut});

          TweenMax.to(svg.find('#bar2s1'),speed,{attr:{height:10.8816,y:4.8707},ease:Power4.easeInOut});
          TweenMax.to(svg.find('#bar2s2'),speed,{attr:{height:45.2438,y:15.7523},ease:Power4.easeInOut});
          TweenMax.to(svg.find('#bar2s3'),speed,{attr:{height:405.1348,y:60.9961},ease:Power4.easeInOut});

          TweenMax.to(svg.find('#bar3s1'),speed,{attr:{height:5.2515,y:4.8707},ease:Power4.easeInOut});
          TweenMax.to(svg.find('#bar3s2'),speed,{attr:{height:29.9814,y:10.1223},ease:Power4.easeInOut});
          TweenMax.to(svg.find('#bar3s3'),speed,{attr:{height:426.0273,y:40.1037},ease:Power4.easeInOut});

          TweenMax.to(svg.find('#bar4s1'),speed,{attr:{height:15.2136,y:4.8707},ease:Power4.easeInOut});
          TweenMax.to(svg.find('#bar4s2'),speed,{attr:{height:44.3676,y:20.0843},ease:Power4.easeInOut});
          TweenMax.to(svg.find('#bar4s3'),speed,{attr:{height:401.6791,y:64.4519},ease:Power4.easeInOut});

          TweenMax.to(svg.find('#bar5s1'),speed,{attr:{height:15.2136,y:4.8707},ease:Power4.easeInOut});
          TweenMax.to(svg.find('#bar5s2'),speed,{attr:{height:70.8767,y:20.0843},ease:Power4.easeInOut});
          TweenMax.to(svg.find('#bar5s3'),speed,{attr:{height:375.17,y:90.961},ease:Power4.easeInOut});

          TweenMax.to(svg.find('#bar6s1'),speed,{attr:{height:23.1078,y:4.8707},ease:Power4.easeInOut});
          TweenMax.to(svg.find('#bar6s2'),speed,{attr:{height:98.8253,y:27.9785},ease:Power4.easeInOut});
          TweenMax.to(svg.find('#bar6s3'),speed,{attr:{height:339.3272,y:126.8038},ease:Power4.easeInOut});

          TweenMax.to(svg.find('#bar7s1'),speed,{attr:{height:35.4473,y:4.8707},ease:Power4.easeInOut});
          TweenMax.to(svg.find('#bar7s2'),speed,{attr:{height:67.527,y:40.318},ease:Power4.easeInOut});
          TweenMax.to(svg.find('#bar7s3'),speed,{attr:{height:358.2859,y:107.845},ease:Power4.easeInOut});

          TweenMax.to(svg.find('#bar8s1'),speed,{attr:{height:5.6596,y:4.8707},ease:Power4.easeInOut});
          TweenMax.to(svg.find('#bar8s2'),speed,{attr:{height:20.2853,y:10.5303},ease:Power4.easeInOut});
          TweenMax.to(svg.find('#bar8s3'),speed,{attr:{height:435.3154,y:30.8156},ease:Power4.easeInOut});

          TweenMax.to(svg.find('#bar9s1'),speed,{attr:{height:10.383,y:4.8707},ease:Power4.easeInOut});
          TweenMax.to(svg.find('#bar9s2'),speed,{attr:{height:20.1968,y:15.2537},ease:Power4.easeInOut});
          TweenMax.to(svg.find('#bar9s3'),speed,{attr:{height:430.6804,y:35.4505},ease:Power4.easeInOut});

          TweenMax.to(svg.find('#bar10s1'),speed,{attr:{height:13.3716,y:4.8707},ease:Power4.easeInOut});
          TweenMax.to(svg.find('#bar10s2'),speed,{attr:{height:17.2082,y:18.2423},ease:Power4.easeInOut});
          TweenMax.to(svg.find('#bar10s3'),speed,{attr:{height:430.6804,y:35.4505},ease:Power4.easeInOut});


          $('#fowtr-chapter2 #fowtr-article9 .chart-title1-state1').fadeOut(function(){
            $('#fowtr-chapter2 #fowtr-article9 .chart-title1-state2').fadeIn();
          });

          $('#fowtr-chapter2 #fowtr-article9 .chart-title2-state1').fadeOut(function(){
            $('#fowtr-chapter2 #fowtr-article9 .chart-title2-state2').fadeIn();
          });


        }

        // var options = {
        //   intentPollInterval:20,
        //   followMouse:true,
        //   fadeInTime:0,
        //   fadeOutTime:0,
        // }

        // $('#fowtr-chapter2 #fowtr-article9 .selector1').data('powertip', 'New Skills').powerTip(options);
        // $('#fowtr-chapter2 #fowtr-article9 .selector2').data('powertip', 'Digital Skills').powerTip(options);


        $('#fowtr-chapter2 #fowtr-article9 .chart-selector').on('click', '.selector', function(event) {
          event.preventDefault();
          $('#fowtr-chapter2 #fowtr-article9 .selector').removeClass('active');
          if($(this).hasClass('selector1')){
            state1();
            $('#fowtr-chapter2 #fowtr-article9 .selector1').addClass('active');
          } else {
            state2();
            $('#fowtr-chapter2 #fowtr-article9 .selector2').addClass('active');
          }
        });


        // inview - trigger play when in view
        svg.one('inview', {offsetTop:200}, function(event, visible) {
            if (visible) {
                tl.play(); //play once only
                // tl.play(0); //play each time from 0
            } else {
              // tl.pause();
              // tl.seek(0);
            }
        });
      });

      if(!fowtr_module_utilities.isMobile){
        $('#fowtr-chapter2 #fowtr-article9 .chart-selector .selector1').data('powertip', 'New Skills').powerTip();
        $('#fowtr-chapter2 #fowtr-article9 .chart-selector .selector2').data('powertip', 'Digital Skills').powerTip();
      }










      // ------------------------------------------------------------------------------------------------------
      // article 11 boxes
      // ------------------------------------------------------------------------------------------------------


      var boxestl = new TimelineMax({paused: true});
      var speed = 0.5;
      var stagger = 0.2;
      var delay = 0.5;
      boxestl.from($('#fowtr-chapter2 #fowtr-article11 .shadow1'),1,{alpha:0,ease:Bounce.easeOut,delay:delay},0);
      boxestl.from($('#fowtr-chapter2 #fowtr-article11 .operations-box-3'),speed,{alpha:0, y:"-=100px",ease:Bounce.easeOut,delay:delay+stagger*0},0);
      boxestl.from($('#fowtr-chapter2 #fowtr-article11 .operations-box-2'),speed,{alpha:0, y:"-=100px",ease:Bounce.easeOut,delay:delay+stagger*1},0);
      boxestl.from($('#fowtr-chapter2 #fowtr-article11 .operations-box-1'),speed,{alpha:0, y:"-=100px",ease:Bounce.easeOut,delay:delay+stagger*2},0);

      delay = 1;
      boxestl.from($('#fowtr-chapter2 #fowtr-article11 .shadow2'),1,{alpha:0,ease:Bounce.easeOut,delay:delay},0);
      boxestl.from($('#fowtr-chapter2 #fowtr-article11 .office-box-3'),speed,{alpha:0, y:"-=100px",ease:Bounce.easeOut,delay:delay+stagger*0},0);
      boxestl.from($('#fowtr-chapter2 #fowtr-article11 .office-box-2'),speed,{alpha:0, y:"-=100px",ease:Bounce.easeOut,delay:delay+stagger*1},0);
      boxestl.from($('#fowtr-chapter2 #fowtr-article11 .office-box-1'),speed,{alpha:0, y:"-=100px",ease:Bounce.easeOut,delay:delay+stagger*2},0);


      $('#fowtr-chapter2 #fowtr-article11 .row').one('inview', {offsetTop:200}, function(event, visible) {
          if (visible) {
              // boxestl.play(); //play once only
              boxestl.play(); //play each time from 0
          } else {
            // boxestl.pause();
            // boxestl.seek(0);
          }
      });




      // // ------------------------------------------------------------------------------------------------------
      // // article 12 svg chart
      // // ------------------------------------------------------------------------------------------------------
      // var element = $("#fowtr-chapter2 #fowtr-article12 .inlinesvg");
      // var article12classes = element.attr('class');
      // fowtr_module_utilities.inlineSvg(element,function(svg){
      //   svg.attr('class',article12classes); //put same classes on the new content

      //   // animation
      //   var tl = new TimelineMax({paused: true});

      //   var stagger,speed,delay;

      //   speed = 0.5;
      //   tl.fromTo(svg.find('#xaxis'),speed,{autoAlpha:0,y:"-10px"},{autoAlpha:1,y:0,ease:Power4.easeOut,delay:0},0);
      //   tl.fromTo(svg.find('#yaxis'),speed,{autoAlpha:0,x:"-20px"},{autoAlpha:1,x:0,ease:Power4.easeOut,delay:0},0);
      //   // tl.fromTo(svg.find('#legend'),speed,{autoAlpha:0,y:"+20px"},{autoAlpha:1,y:0,ease:Power4.easeOut,delay:0},0.2);
      //   tl.fromTo(svg.find('#grid'),speed,{autoAlpha:0},{autoAlpha:1,delay:0},0);

      //   stagger = 0.1;
      //   delay = 0.5;
      //   speed = 1;
      //   tl.fromTo(svg.find('#bar1'),speed,{attr:{height:0}},{attr:{height:492.5844},ease:Power4.easeInOut,delay:delay+stagger*0},0);
      //   tl.fromTo(svg.find('#bar2'),speed,{attr:{height:0}},{attr:{height:484.4931},ease:Power4.easeInOut,delay:delay+stagger*1},0);
      //   tl.fromTo(svg.find('#bar3'),speed,{attr:{height:0}},{attr:{height:422.0349},ease:Power4.easeInOut,delay:delay+stagger*2},0);
      //   tl.fromTo(svg.find('#bar4'),speed,{attr:{height:0}},{attr:{height:414.186},ease:Power4.easeInOut,delay:delay+stagger*3},0);
      //   tl.fromTo(svg.find('#bar5'),speed,{attr:{height:0}},{attr:{height:188.2036},ease:Power4.easeInOut,delay:delay+stagger*4},0);
      //   tl.fromTo(svg.find('#bar6'),speed,{attr:{height:0}},{attr:{height:178.2737},ease:Power4.easeInOut,delay:delay+stagger*5},0);
      //   tl.fromTo(svg.find('#bar7'),speed,{attr:{height:0}},{attr:{height:137.9078},ease:Power4.easeInOut,delay:delay+stagger*6},0);
      //   tl.fromTo(svg.find('#bar8'),speed,{attr:{height:0}},{attr:{height:66.621},ease:Power4.easeInOut,delay:delay+stagger*7},0);
        
      //   tl.fromTo(svg.find('#numbers'),0.5,{autoAlpha:0,x:"+1px"},{autoAlpha:1,x:0,delay:0},1.5);

      //   // inview - trigger play when in view
      //   svg.one('inview', {offsetTop:200}, function(event, visible) {
      //       if (visible) {
      //           // tl.play(); //play once only
      //           tl.play(0); //play each time from 0
      //       } else {
      //         tl.pause();
      //         tl.seek(0);
      //       }
      //   });
      // });







      // // ------------------------------------------------------------------------------------------------------
      // // article 13 svg chart
      // // ------------------------------------------------------------------------------------------------------
      // var element = $("#fowtr-chapter2 #fowtr-article13 .inlinesvg");
      // var article12classes = element.attr('class');
      // fowtr_module_utilities.inlineSvg(element,function(svg){
      //   svg.attr('class',article12classes); //put same classes on the new content

      //   // animation
      //   var tl = new TimelineMax({paused: true});

      //   var stagger,speed,delay;

      //   speed = 0.5;
      //   tl.fromTo(svg.find('#xaxis'),speed,{autoAlpha:0,y:"-10px"},{autoAlpha:1,y:0,ease:Power4.easeOut,delay:0},0);
      //   tl.fromTo(svg.find('#yaxis'),speed,{autoAlpha:0,x:"-20px"},{autoAlpha:1,x:0,ease:Power4.easeOut,delay:0},0);
      //   // tl.fromTo(svg.find('#legend'),speed,{autoAlpha:0,y:"+20px"},{autoAlpha:1,y:0,ease:Power4.easeOut,delay:0},0.2);
      //   tl.fromTo(svg.find('#grid'),speed,{autoAlpha:0},{autoAlpha:1,delay:0},0);

      //   stagger = 0.1;
      //   delay = 0.5;
      //   speed = 1;
      //   tl.fromTo(svg.find('#bar1'),speed,{attr:{height:0}},{attr:{height:398.9188},ease:Power4.easeInOut,delay:delay+stagger*0},0);
      //   tl.fromTo(svg.find('#bar2'),speed,{attr:{height:0}},{attr:{height:381.8917},ease:Power4.easeInOut,delay:delay+stagger*1},0);
      //   tl.fromTo(svg.find('#bar3'),speed,{attr:{height:0}},{attr:{height:368.0445},ease:Power4.easeInOut,delay:delay+stagger*2},0);
      //   tl.fromTo(svg.find('#bar4'),speed,{attr:{height:0}},{attr:{height:353.8881},ease:Power4.easeInOut,delay:delay+stagger*3},0);
      //   tl.fromTo(svg.find('#bar5'),speed,{attr:{height:0}},{attr:{height:353.8881},ease:Power4.easeInOut,delay:delay+stagger*4},0);
      //   tl.fromTo(svg.find('#bar6'),speed,{attr:{height:0}},{attr:{height:337.4637},ease:Power4.easeInOut,delay:delay+stagger*5},0);
      //   tl.fromTo(svg.find('#bar7'),speed,{attr:{height:0}},{attr:{height:324.8687},ease:Power4.easeInOut,delay:delay+stagger*6},0);
      //   tl.fromTo(svg.find('#bar8'),speed,{attr:{height:0}},{attr:{height:208.1779},ease:Power4.easeInOut,delay:delay+stagger*7},0);
        
      //   tl.fromTo(svg.find('#numbers'),0.5,{autoAlpha:0,x:"+1px"},{autoAlpha:1,x:0,delay:0},1.8);

      //   // inview - trigger play when in view
      //   svg.one('inview', {offsetTop:200}, function(event, visible) {
      //       if (visible) {
      //           // tl.play(); //play once only
      //           tl.play(0); //play each time from 0
      //       } else {
      //         tl.pause();
      //         tl.seek(0);
      //       }
      //   });
      // });










      // ------------------------------------------------------------------------------------------------------
      // article 14 svg chart
      // ------------------------------------------------------------------------------------------------------
      var element = $("#fowtr-chapter2 #fowtr-article14 .inlinesvg");
      var article9classes = element.attr('class');
      fowtr_module_utilities.inlineSvg(element,function(svg){
        svg.attr('class',article9classes); //put same classes on the new content

        // svg.find('rect').css({'transform-box':'fill-box','transform-origin':'100%'});

        // animation
        var tl = new TimelineMax({paused: true});

        var stagger,speed,delay;

        speed = 2;
        tl.fromTo(svg.find('#labels'),speed,{autoAlpha:0},{autoAlpha:1,ease:Power4.easeOut,delay:0},0);
        

        delay += 0.1;
        // tl.to($('#fowtr-chapter2 #fowtr-article14 .chart-title-state1'),0.5,{autoAlpha:1,ease:Linear.easeNone,delay:delay},0);
        tl.to($('#fowtr-chapter2 #fowtr-article14 .chart-selector-wrapper'),0.5,{autoAlpha:1,ease:Linear.easeNone,delay:delay},0);
        $('#fowtr-chapter2 #fowtr-article14 .chart-title-state1').fadeIn();


        function out(){
          var stagger = 0.01;
          for (var i = 7; i > 0; i--) {
            TweenMax.to(svg.find('#UPSKILLING-OPS #h'+i),0.2,{opacity:0,ease:Power4.easeInOut,delay:stagger*i});
            TweenMax.to(svg.find('#UPSKILLING-OFFICE #h'+i+'-2'),0.2,{opacity:0,ease:Power4.easeInOut,delay:stagger*i});
            TweenMax.to(svg.find('#UPSKILLING-INCOMING_GEN #h'+i+'-3'),0.2,{opacity:0,ease:Power4.easeInOut,delay:stagger*i});
            TweenMax.to(svg.find('#UPSKILLING-UPPER_MGMT #h'+i+'-4'),0.2,{opacity:0,ease:Power4.easeInOut,delay:stagger*i});
          }
        }


        function state1(){
          out();
          var stagger = 0.05;
          var delay = 0.3;
          for (var i = 1; i < 8; i++) {
            // TweenMax.to(svg.find('#UPSKILLING-OPS #h'+i),0.5,{opacity:1,ease:Power4.easeInOut,delay:delay+stagger*i});
            TweenMax.fromTo(svg.find('#UPSKILLING-OPS #h'+i),0.5,{opacity:0,scale:0},{opacity:1,scale:1,ease:"back.out(1.5)",delay:delay+stagger*i});
          }
          $('#fowtr-chapter2 #fowtr-article14 .chart-title:visible').fadeOut('fast',function(){
            $('#fowtr-chapter2 #fowtr-article14 .chart-title-state1').fadeIn();
          });
        }

        function state2(){
          out();
          var stagger = 0.05;
          var delay = 0.3;
          for (var i = 1; i < 8; i++) {
            // TweenMax.to(svg.find('#UPSKILLING-OFFICE #h'+i+'-2'),0.5,{opacity:1,ease:Power4.easeInOut,delay:delay+stagger*i});
            TweenMax.fromTo(svg.find('#UPSKILLING-OFFICE #h'+i+'-2'),0.5,{opacity:0,scale:0},{opacity:1,scale:1,ease:"back.out(1.5)",delay:delay+stagger*i});
          }
          $('#fowtr-chapter2 #fowtr-article14 .chart-title:visible').fadeOut('fast',function(){
            $('#fowtr-chapter2 #fowtr-article14 .chart-title-state2').fadeIn();
          });
        }
        function state3(){
          out();
          var stagger = 0.05;
          var delay = 0.3;
          for (var i = 1; i < 8; i++) {
            // TweenMax.to(svg.find('#UPSKILLING-INCOMING_GEN #h'+i+'-3'),0.5,{opacity:1,ease:Power4.easeInOut,delay:delay+stagger*i});
            TweenMax.fromTo(svg.find('#UPSKILLING-INCOMING_GEN #h'+i+'-3'),0.5,{opacity:0,scale:0},{opacity:1,scale:1,ease:"back.out(1.5)",delay:delay+stagger*i});
          }
          $('#fowtr-chapter2 #fowtr-article14 .chart-title:visible').fadeOut('fast',function(){
            $('#fowtr-chapter2 #fowtr-article14 .chart-title-state3').fadeIn();
          });
        }
        function state4(){
          out();
          var stagger = 0.05;
          var delay = 0.3;
          for (var i = 1; i < 8; i++) {
            // TweenMax.to(svg.find('#UPSKILLING-UPPER_MGMT #h'+i+'-4'),0.5,{opacity:1,ease:Power4.easeInOut,delay:delay+stagger*i});
            TweenMax.fromTo(svg.find('#UPSKILLING-UPPER_MGMT #h'+i+'-4'),0.5,{opacity:0,scale:0},{opacity:1,scale:1,ease:"back.out(1.5)",delay:delay+stagger*i});
          }
          $('#fowtr-chapter2 #fowtr-article14 .chart-title:visible').fadeOut('fast',function(){
            $('#fowtr-chapter2 #fowtr-article14 .chart-title-state4').fadeIn();
          });
        }


        // var options = {
        //   intentPollInterval:20,
        //   followMouse:true,
        //   fadeInTime:0,
        //   fadeOutTime:0,
        // }

        // $('#fowtr-chapter2 #fowtr-article9 .selector1').data('powertip', 'New Skills').powerTip(options);
        // $('#fowtr-chapter2 #fowtr-article9 .selector2').data('powertip', 'Digital Skills').powerTip(options);


        $('#fowtr-chapter2 #fowtr-article14 .chart-selector').on('click', '.selector', function(event) {
          event.preventDefault();
          if($(this).hasClass('active')) return false;
          $('#fowtr-chapter2 #fowtr-article14 .selector').removeClass('active');
          if($(this).hasClass('selector1')){
            state1();
            $('#fowtr-chapter2 #fowtr-article14 .selector1').addClass('active');
          }
          if($(this).hasClass('selector2')){
            state2();
            $('#fowtr-chapter2 #fowtr-article14 .selector2').addClass('active');
          }
          if($(this).hasClass('selector3')){
            state3();
            $('#fowtr-chapter2 #fowtr-article14 .selector3').addClass('active');
          }
          if($(this).hasClass('selector4')){
            state4();
            $('#fowtr-chapter2 #fowtr-article14 .selector4').addClass('active');
          }
        });


        // inview - trigger play when in view
        svg.one('inview', {offsetTop:200}, function(event, visible) {
            if (visible) {
              state1();
              tl.play(); //play once only
              // tl.play(0); //play each time from 0
            } else {
              // tl.pause();
              // tl.seek(0);
            }
        });
      });


      var options = {
        // intentPollInterval:20,
        // followMouse:true,
        // fadeInTime:0,
        // fadeOutTime:0,
      }

      
      if(!fowtr_module_utilities.isMobile){
        $('#fowtr-chapter2 #fowtr-article14 .chart-selector .selector1').data('powertip', 'Operations').powerTip();
        $('#fowtr-chapter2 #fowtr-article14 .chart-selector .selector2').data('powertip', 'Office').powerTip();
        $('#fowtr-chapter2 #fowtr-article14 .chart-selector .selector3').data('powertip', 'Incoming Generation').powerTip();
        $('#fowtr-chapter2 #fowtr-article14 .chart-selector .selector4').data('powertip', 'Upper Management').powerTip();
      }






      // ------------------------------------------------------------------------------------------------------
      // article 16 svg chart
      // ------------------------------------------------------------------------------------------------------
      var element = $("#fowtr-chapter2 #fowtr-article16 .inlinesvg");
      var article16classes = element.attr('class');
      fowtr_module_utilities.inlineSvg(element,function(svg){
        svg.attr('class',article16classes); //put same classes on the new content

        // animation
        var tl = new TimelineMax({paused: true});

        var stagger,speed,delay;

        speed = 0.5;
        tl.fromTo(svg.find('#xaxis'),speed,{autoAlpha:0,y:"-10px"},{autoAlpha:1,y:0,ease:Power4.easeOut,delay:0},0);
        tl.fromTo(svg.find('#yaxis'),speed,{autoAlpha:0,x:"-20px"},{autoAlpha:1,x:0,ease:Power4.easeOut,delay:0},0);
        // tl.fromTo(svg.find('#legend'),speed,{autoAlpha:0,y:"+20px"},{autoAlpha:1,y:0,ease:Power4.easeOut,delay:0},0.2);
        tl.fromTo(svg.find('#grid'),speed,{autoAlpha:0},{autoAlpha:1,delay:0},0);

        for (var i = 1; i <= 15; i++) {
          var centerx = svg.find('#b'+i)[0].getBoundingClientRect().width / 2;
          var centery = svg.find('#b'+i)[0].getBoundingClientRect().height / 2;
          svg.find('#b'+i).css('transform-origin',centerx+'px '+centery+'px');
        }


        stagger = 0.1;
        delay = 0.5;
        speed = 1;
        for (var i = 1; i <= 15; i++) {
          tl.fromTo(svg.find('#b'+i),speed,{scale:0},{scale:1,ease:Power4.easeOut,delay:delay+stagger*i},0);
        }


        var options = {
          intentPollInterval:20,
          followMouse:true,
          fadeInTime:0,
          fadeOutTime:0,
        }
        if(fowtr_module_utilities.isMobile) options = {};


        svg.find('#b1').data('powertip', '41%').powerTip(options);
        svg.find('#b2').data('powertip', '30%').powerTip(options);
        svg.find('#b3').data('powertip', '19%').powerTip(options);
        svg.find('#b4').data('powertip', '7%').powerTip(options);
        svg.find('#b5').data('powertip', '4%').powerTip(options);
        svg.find('#b6').data('powertip', '19%').powerTip(options);
        svg.find('#b7').data('powertip', '33%').powerTip(options);
        svg.find('#b8').data('powertip', '29%').powerTip(options);
        svg.find('#b9').data('powertip', '11%').powerTip(options);
        svg.find('#b10').data('powertip', '9%').powerTip(options);
        svg.find('#b11').data('powertip', '9%').powerTip(options);
        svg.find('#b12').data('powertip', '41%').powerTip(options);
        svg.find('#b13').data('powertip', '28%').powerTip(options);
        svg.find('#b14').data('powertip', '7%').powerTip(options);
        svg.find('#b15').data('powertip', '16%').powerTip(options);


        // inview - trigger play when in view
        svg.one('inview', {offsetTop:200}, function(event, visible) {
            if (visible) {
                tl.play(); //play once only
                // tl.play(0); //play each time from 0
            } else {
              // tl.pause();
              // tl.seek(0);
            }
        });
      });






      // ------------------------------------------------------------------------------------------------------
      // article 17 svg chart
      // ------------------------------------------------------------------------------------------------------
      var element = $("#fowtr-chapter2 #fowtr-article17 .inlinesvg");
      var article17classes = element.attr('class');
      fowtr_module_utilities.inlineSvg(element,function(svg){
        svg.attr('class',article17classes); //put same classes on the new content

        // animation
        var tl = new TimelineMax({paused: true});

        var stagger,speed,delay;

        speed = 0.5;
        tl.fromTo(svg.find('#xaxis'),speed,{autoAlpha:0,y:"+5px"},{autoAlpha:1,y:0,ease:Power4.easeOut,delay:0},0);
        tl.fromTo(svg.find('#yaxis'),speed,{autoAlpha:0,x:"-5px"},{autoAlpha:1,x:0,ease:Power4.easeOut,delay:0},0);
        // tl.fromTo(svg.find('#legend'),speed,{autoAlpha:0,y:"+5px"},{autoAlpha:1,y:0,ease:Power4.easeOut,delay:0},0.2);
        tl.fromTo(svg.find('#grid'),speed,{autoAlpha:0},{autoAlpha:1,delay:0},0);


        stagger = 0.1;
        delay = 0.2;
        speed = 1;
        for (var i = 1; i <= 15; i++) {
          // tl.fromTo(svg.find('#b'+i),speed,{scale:0},{scale:1,ease:Power4.easeOut,delay:delay+stagger*i},0);
          tl.from(svg.find('#bar'+i+' rect'),speed,{attr:{height:0},ease:Power4.easeInOut,delay:delay+stagger*i},0);
        }

        var options = {
          intentPollInterval:20,
          followMouse:true,
          fadeInTime:0,
          fadeOutTime:0,
          // openEvents:['mouseover','focus']
          // closeDelay:0
        }
        if(fowtr_module_utilities.isMobile) options = {};

        svg.find('#bar1').data('powertip', '41%').powerTip(options);
        svg.find('#bar2').data('powertip', '43%').powerTip(options);
        svg.find('#bar3').data('powertip', '15%').powerTip(options);
        svg.find('#bar4').data('powertip', '47%').powerTip(options);
        svg.find('#bar5').data('powertip', '40%').powerTip(options);
        svg.find('#bar6').data('powertip', '13%').powerTip(options);
        svg.find('#bar7').data('powertip', '45%').powerTip(options);
        svg.find('#bar8').data('powertip', '41%').powerTip(options);
        svg.find('#bar9').data('powertip', '13%').powerTip(options);
        svg.find('#bar10').data('powertip', '40%').powerTip(options);
        svg.find('#bar11').data('powertip', '40%').powerTip(options);
        svg.find('#bar12').data('powertip', '20%').powerTip(options);
        svg.find('#bar13').data('powertip', '34%').powerTip(options);
        svg.find('#bar14').data('powertip', '37%').powerTip(options);
        svg.find('#bar15').data('powertip', '27%').powerTip(options);


        // inview - trigger play when in view
        svg.one('inview', {offsetTop:200}, function(event, visible) {
            if (visible) {
                tl.play(); //play once only
                // tl.play(0); //play each time from 0
            } else {
              // tl.pause();
              // tl.seek(0);
            }
        });
      });









      // ------------------------------------------------------------------------------------------------------
      // article 18 svg chart
      // ------------------------------------------------------------------------------------------------------
      var element = $("#fowtr-chapter2 #fowtr-article18 .inlinesvg");
      var article18classes = element.attr('class');
      fowtr_module_utilities.inlineSvg(element,function(svg){
        svg.attr('class',article18classes); //put same classes on the new content

        // animation
        var tl = new TimelineMax({paused: true});

        var stagger,speed,delay;

        speed = 0.5;
        tl.fromTo(svg.find('#xaxis'),speed,{autoAlpha:0,y:"-10px"},{autoAlpha:1,y:0,ease:Power4.easeOut,delay:0},0);
        tl.fromTo(svg.find('#yaxis'),speed,{autoAlpha:0,x:"-20px"},{autoAlpha:1,x:0,ease:Power4.easeOut,delay:0.3},0);
        // tl.fromTo(svg.find('#legend'),speed,{autoAlpha:0,y:"+20px"},{autoAlpha:1,y:0,ease:Power4.easeOut,delay:0},0.2);
        tl.fromTo(svg.find('#grid'),speed,{autoAlpha:0},{autoAlpha:1,delay:0},0);

        // var centerx = svg.find('#arrows')[0].getBoundingClientRect().width / 2;
        // var centery = svg.find('#arrows')[0].getBoundingClientRect().height / 2;
        // svg.find('#arrows').css('transform-origin',centerx+'px '+centery+'px');
        svg.find('#arrows').css('transform-origin','461px 12px');
        tl.fromTo(svg.find('#arrows'),1.5,{autoAlpha:0,scaleX:0},{autoAlpha:1,scaleX:1,ease:Power4.easeOut,delay:0},0);

        for (var i = 1; i <= 25; i++) {
          var centerx = svg.find('#b'+i)[0].getBoundingClientRect().width / 2;
          var centery = svg.find('#b'+i)[0].getBoundingClientRect().height / 2;
          svg.find('#b'+i).css('transform-origin',centerx+'px '+centery+'px');
        }


        stagger = 0.07;
        delay = 0.5;
        speed = 1;
        for (var i = 1; i <= 25; i++) {
          tl.fromTo(svg.find('#b'+i),speed,{scale:0},{scale:1,ease:Power4.easeOut,delay:delay+stagger*i},0);
        }

        var options = {
          intentPollInterval:20,
          followMouse:true,
          fadeInTime:0,
          fadeOutTime:0,
          // openEvents:['mouseover','focus']
          // closeDelay:0
        }
        if(fowtr_module_utilities.isMobile) options = {};
        
        svg.find('#b1').data('powertip', '12%').powerTip(options);
        svg.find('#b2').data('powertip', '23%').powerTip(options);
        svg.find('#b3').data('powertip', '22%').powerTip(options);
        svg.find('#b4').data('powertip', '28%').powerTip(options);
        svg.find('#b5').data('powertip', '16%').powerTip(options);
        svg.find('#b6').data('powertip', '39%').powerTip(options);
        svg.find('#b7').data('powertip', '29%').powerTip(options);
        svg.find('#b8').data('powertip', '18%').powerTip(options);
        svg.find('#b9').data('powertip', '6%').powerTip(options);
        svg.find('#b10').data('powertip', '4%').powerTip(options);
        svg.find('#b11').data('powertip', '33%').powerTip(options);
        svg.find('#b12').data('powertip', '36%').powerTip(options);
        svg.find('#b13').data('powertip', '19%').powerTip(options);
        svg.find('#b14').data('powertip', '7%').powerTip(options);
        svg.find('#b15').data('powertip', '3%').powerTip(options);
        svg.find('#b16').data('powertip', '24%').powerTip(options);
        svg.find('#b17').data('powertip', '31%').powerTip(options);
        svg.find('#b18').data('powertip', '21%').powerTip(options);
        svg.find('#b19').data('powertip', '15%').powerTip(options);
        svg.find('#b20').data('powertip', '5%').powerTip(options);
        svg.find('#b21').data('powertip', '16%').powerTip(options);
        svg.find('#b22').data('powertip', '24%').powerTip(options);
        svg.find('#b23').data('powertip', '25%').powerTip(options);
        svg.find('#b24').data('powertip', '21%').powerTip(options);
        svg.find('#b25').data('powertip', '8%').powerTip(options);


        // inview - trigger play when in view
        svg.one('inview', {offsetTop:200}, function(event, visible) {
            if (visible) {
                tl.play(); //play once only
                // tl.play(0); //play each time from 0
            } else {
              // tl.pause();
              // tl.seek(0);
            }
        });
      });






      // // ------------------------------------------------------------------------------------------------------
      // // article 20 click icon and survey
      // // ------------------------------------------------------------------------------------------------------
      // var element = $("#fowtr-chapter2 #fowtr-article19 .fowtr-signup .click_icon");
      // var article19classes = element.attr('class');
      // fowtr_module_utilities.inlineSvg(element,function(svg){
      //   svg.attr('class',article19classes); //put same classes on the new content
      //   var tl = new TimelineMax({repeat:-1});
      //   tl.fromTo(svg.find('#ring'),2,{x:"-=0%",y:"-=0%",scale:1,opacity:1},{x:"-=7px",y:"-=8px",scale:2,opacity:0,ease:Power4.easeOut},0);
      // });

      // var element = $("#fowtr-chapter2 #fowtr-article19 .fowtr-survey .click_icon");
      // var article19classes = element.attr('class');
      // fowtr_module_utilities.inlineSvg(element,function(svg){
      //   svg.attr('class',article19classes); //put same classes on the new content
      //   var tl = new TimelineMax({repeat:-1});
      //   tl.fromTo(svg.find('#ring'),2,{x:"-=0%",y:"-=0%",scale:1,opacity:1},{x:"-=7px",y:"-=8px",scale:2,opacity:0,ease:Power4.easeOut},0);
      // });






      // survey / Usabilla



      // set up as a SPA
      // window.usabilla_live('virtualPageView');

      // button handler
      $('#fowtr-chapter2 #fowtr-article19 .fowtr-survey').click(function(event) {
        event.preventDefault();
        try {
          window.usabilla_live('trigger', 'fow_survey_trigger');
          $(this).addClass('disabled');
        } catch(e) {
          console.warn('usabilla_live not found');
        }
      });

      // event callback
      try {
        resetUsabilla();
        window.usabilla_live('setEventCallback', function(category, action, label, value, userData){
          console.log('setEventCallback',action);
          if(action === "Campaign:Success" || action === "Campaign:Close") {
            resetUsabilla();
          }
        });
      } catch(e) {
        console.warn('usabilla_live not found');
      }


      // usbl.b2d2adfa16cf.c.d5cf372bcc76


      function resetUsabilla(){
        try {
          var arr = [];
          for (var i = 0; i < localStorage.length; i++){
            if (localStorage.key(i).substring(0,18) == 'usbl.b2d2adfa16cf.') {
              arr.push(localStorage.key(i));
            }
          }
          for (var i = 0; i < arr.length; i++) {
            localStorage.removeItem(arr[i]);
          }
        } catch(e) {
          console.warn('usabilla_live not found');
        }
      }


      // $(window).unload(function() {
      //   resetUsabilla();
      // });
      resetUsabilla();
      $(window).on('beforeunload', function(){
        resetUsabilla();
      });




      if(fowtr_module_utilities.disableFancyStuff) forkliftTl.progress(1, false);
      if(fowtr_module_utilities.disableFancyStuff) forkliftNumbersTl.progress(1, false);
      if(fowtr_module_utilities.disableFancyStuff) donut1tl.progress(1, false);
      if(fowtr_module_utilities.disableFancyStuff) donut2tl.progress(1, false);
      if(fowtr_module_utilities.disableFancyStuff) boxestl.progress(1, false);









    };//end init function







    fowtr_module_chapter_2.destroy = function(chapter){
      
      console.log('destroy chapter '+chapter);


    };//end destroy function



    return fowtr_module_chapter_2;
}(fowtr_module_chapter_2 || {}));

